document.addEventListener('DOMContentLoaded', function() {
    const addonsContainers = document.querySelectorAll('.product-addons');
    
    addonsContainers.forEach(addonsContainer => {
        initializeAddons(addonsContainer);
    });
});

function initializeAddons(addonsContainer) {
    if (!addonsContainer) return;

    // Get variant data from within this specific container's context
    const variantDataScript = document.querySelector('[data-addon-variants-data]');
    const variantData = variantDataScript ? JSON.parse(variantDataScript.textContent) : {};

    const checkboxes = addonsContainer.querySelectorAll('.product-addon__checkbox');
    const productForm = document.querySelector('.product-form form');

    // Get currency symbol from the page (fallback to $)
    const currencySymbol = getCurrencySymbol();

    // Make main content clickable
    addonsContainer.querySelectorAll('.product-addon__main-content').forEach(mainContent => {
        mainContent.addEventListener('click', function(e) {
            e.preventDefault();
            const checkboxId = this.dataset.addonCheckbox;
            const checkbox = document.getElementById(checkboxId);
            if (checkbox) {
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(new Event('change'));
            }
        });
    });

    // Show/hide variants when checkbox is checked
    function toggleVariants(checkbox, show) {
        const addonIndex = checkbox.dataset.addonIndex;
        const variantsContainer = addonsContainer.querySelector(`[data-addon-variants="${addonIndex}"]`);

        if (variantsContainer) {
            variantsContainer.style.display = show ? 'block' : 'none';
        }
    }

    // Find variant based on selected options
    function findVariantByOptions(productId, selectedOptions) {
        const variants = variantData[productId];
        if (!variants) return null;

        return variants.find(variant => {
            return variant.available && variant.options.every((option, index) => {
                return option === selectedOptions[index + 1];
            });
        });
    }

    // Update image based on variant selection
    function updateVariantImage(addonIndex, productId, selectedOptions) {
        const gallery = addonsContainer.querySelector(`[data-addon-index="${addonIndex}"][data-media-carousel]`);
        if (!gallery) return;

        const variant = findVariantByOptions(productId, selectedOptions);
        if (!variant || !variant.featured_media) return;

        const img = gallery.querySelector('.upsell-card__image--active');
        if (!img) return;

        const media = variant.featured_media;
        const mediaSrc = media.preview_image?.src ? `https:${media.preview_image.src}` : '';
        img.src = mediaSrc;
        img.srcset = mediaSrc ? `${mediaSrc} 165w, ${mediaSrc} 360w` : '';
        img.dataset.mediaId = media.id;
        img.alt = '';
    }

    // Update variant selection and price
    function updateVariant(addonIndex, productId) {
        const variantInputs = addonsContainer.querySelectorAll(`[data-addon-index="${addonIndex}"].addon-variant-input:checked`);
        const selectedOptions = {};

        variantInputs.forEach(input => {
            selectedOptions[input.dataset.optionPosition] = input.value;
        });

        const variant = findVariantByOptions(productId, selectedOptions);
        if (variant) {
            // Update checkbox data
            const checkbox = addonsContainer.querySelector(`[data-addon-index="${addonIndex}"].product-addon__checkbox`);
            if (checkbox) {
                checkbox.dataset.variantId = variant.id;
                checkbox.dataset.variantPrice = variant.price;
            }

            // Update price display
            const priceElement = checkbox.closest('.product-addon__item').querySelector('.price__current');
            if (priceElement) {
                const price = variant.price / 100;
                
                let formattedPrice;
                if (price % 1 === 0) {
                    formattedPrice = currencySymbol + price.toString();
                } else {
                    formattedPrice = currencySymbol + price.toFixed(2).replace(/\.?0+$/, '');
                }
                
                priceElement.textContent = formattedPrice;
            }

            // Update selected variant value display
            Object.keys(selectedOptions).forEach(position => {
                const valueDisplay = addonsContainer.querySelector(`[data-addon-variants="${addonIndex}"] .addon-variant-value[data-option-position="${position}"]`);
                if (valueDisplay) {
                    valueDisplay.textContent = selectedOptions[position];
                }
            });

            // Update variant image
            updateVariantImage(addonIndex, productId, selectedOptions);
        }

        updateHiddenFields();
    }

    // Update hidden fields for selected add-ons
    function updateHiddenFields() {
        if (!productForm) return;

        const selectedAddons = Array.from(checkboxes).filter(cb => cb.checked);

        // Remove existing addon hidden fields
        const existingFields = productForm.querySelectorAll('input[name^="items["]');
        existingFields.forEach(field => field.remove());

        // Add hidden fields for selected add-ons
        selectedAddons.forEach((checkbox, index) => {
            const variantId = checkbox.dataset.variantId;
            const itemIndex = index + 1;
            
            const hiddenId = document.createElement('input');
            hiddenId.type = 'hidden';
            hiddenId.name = `items[${itemIndex}][id]`;
            hiddenId.value = variantId;
            
            const hiddenQty = document.createElement('input');
            hiddenQty.type = 'hidden';
            hiddenQty.name = `items[${itemIndex}][quantity]`;
            hiddenQty.value = '1';
            
            productForm.appendChild(hiddenId);
            productForm.appendChild(hiddenQty);
        });
    }

    // Listen for checkbox changes
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            toggleVariants(this, this.checked);
            updateHiddenFields();
        });
    });

    // Listen for variant option changes
    addonsContainer.addEventListener('change', function(e) {
        if (e.target.classList.contains('addon-variant-input')) {
            const addonIndex = e.target.dataset.addonIndex;
            const productId = e.target.closest('.addon-variant-picker').dataset.productId;
            updateVariant(addonIndex, productId);
        }
    });
addonsContainer.addEventListener('click', async function (e) {
  const btn = e.target.closest('.addon-atc-btn');
  if (!btn) return;

  const index = btn.dataset.addonIndex;
  const checkbox = addonsContainer.querySelector(
    `[data-addon-index="${index}"].product-addon__checkbox`
  );
  const variantId = checkbox?.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Adding...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error('Failed to add to cart');

    btn.textContent = 'Added!';

    // refresh cart sections
    const cartResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    const sections = await cartResponse.json();

    if (sections['cart-drawer']) {
      document.querySelector('cart-drawer').innerHTML =
        new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html')
          .body.innerHTML;
    }

    if (sections['cart-icon-bubble']) {
      document.querySelector('#cart-icon-bubble').innerHTML =
        new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html')
          .body.innerHTML;
    }

    document.querySelector('#cart-icon-bubble')?.click();

  } catch (err) {
    console.error('Addon ATC error:', err);
    btn.textContent = 'Error — try again';
  } finally {
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  }
});
document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('cart-drawer button[name="close"], cart-drawer .drawer__close, cart-drawer [data-close]');

  if (!closeBtn) return;

  const drawer = document.querySelector('cart-drawer.active');
  if (drawer) {
    drawer.classList.remove('active');
  }

  // safety cleanup (some themes also lock scroll)
  document.documentElement.classList.remove('overflow-hidden');
  document.body.classList.remove('overflow-hidden');
});
   // Sync addon color swatch order + selection with main product's color (only if setting enabled)
// Sync addon color swatch order + selection with main product's color (only if setting enabled)
    const scopedProductInfo = addonsContainer.closest('product-info');

    function syncAddonColors(selectedColor) {
        const syncEnabled = addonsContainer.dataset.syncColors === 'true';
        if (!syncEnabled) return;

        const mainPicker = scopedProductInfo
            ? scopedProductInfo.querySelector('variant-selects[data-color-order]')
            : document.querySelector('variant-selects[data-color-order]');
        if (!mainPicker) return;

        const colorOrder = mainPicker.getAttribute('data-color-order');
        if (!colorOrder) return;

        const orderedColors = colorOrder.split('|').map(c => c.trim().toLowerCase());

        // Determine which color the addons should match: passed-in value,
        // or the server-rendered selected value (reliable on load), or the
        // checked main radio, or fall back to first in order.
        let targetColor = selectedColor;
        if (!targetColor) {
            const selectedValueEl = mainPicker.querySelector('[data-selected-value]');
            const checkedInput = mainPicker.querySelector('input[name="Color"]:checked');
            targetColor = (selectedValueEl && selectedValueEl.textContent.trim())
                || (checkedInput ? checkedInput.value : orderedColors[0]);
        }
        targetColor = targetColor.trim().toLowerCase();

        const addonSelectors = addonsContainer.querySelectorAll('.addon-variant-selector');

        addonSelectors.forEach(selector => {
            const inputs = Array.from(selector.querySelectorAll('input.addon-color-swatch-input'));
            if (inputs.length === 0) return;

            const swatchMap = {};
            inputs.forEach(input => {
                swatchMap[input.value.trim().toLowerCase()] = input;
            });

            inputs.forEach(input => {
                if (input.parentNode) input.parentNode.removeChild(input);
            });

            orderedColors.forEach(colorName => {
                if (swatchMap[colorName]) {
                    selector.appendChild(swatchMap[colorName]);
                }
            });

            Object.keys(swatchMap).forEach(colorName => {
                if (orderedColors.indexOf(colorName) === -1) {
                    selector.appendChild(swatchMap[colorName]);
                }
            });

            // Match the main product's color; fall back to first swatch if
            // this addon doesn't come in that color.
            const targetInput = swatchMap[targetColor] || selector.querySelector('input.addon-color-swatch-input');
            if (!targetInput) return;

            inputs.forEach(inp => { inp.checked = false; });
            targetInput.checked = true;

            const addonIndex = targetInput.dataset.addonIndex;
            const pickerEl = selector.closest('.addon-variant-picker');
            if (!pickerEl) return;
            const productId = pickerEl.dataset.productId;

            updateVariant(addonIndex, productId);
        });
    }
// Initialize — capture the correct color RIGHT NOW, before any
    // third-party script has a chance to tamper with the main picker.
let cachedInitialColor = null;
    (function captureInitialColor() {
        const mainPicker = scopedProductInfo
            ? scopedProductInfo.querySelector('variant-selects[data-color-order]')
            : document.querySelector('variant-selects[data-color-order]');
        if (!mainPicker) return;
        const selectedValueEl = mainPicker.querySelector('[data-selected-value]');
        const checkedInput = mainPicker.querySelector('input[name="Color"]:checked');
        cachedInitialColor = (selectedValueEl && selectedValueEl.textContent.trim())
            || (checkedInput ? checkedInput.value : null);
    })();

    syncAddonColors(cachedInitialColor);
    updateHiddenFields();

    // Re-sync addons when main product color changes (delegated — survives re-renders)
document.addEventListener('change', function(e) {
        if (!e.target.matches('variant-selects input[name="Color"]') || !e.target.checked) return;
        // Only react to color changes within THIS addon block's own product-info,
        // ignoring any other variant-selects on the page (e.g. cart drawer upsells).
        if (scopedProductInfo && e.target.closest('product-info') !== scopedProductInfo) return;
        cachedInitialColor = e.target.value;
        syncAddonColors(e.target.value);
    });

// A third-party app (variant-restrictions.min.js) force-checks the first
    // swatch in every color radio group shortly after load, including our
    // addon swatches (and possibly the main picker), overriding our correct
    // sync. Rather than guessing timing with fixed delays (which causes a
    // visible flash each time), watch continuously for a couple seconds and
    // correct instantly the moment anything gets tampered with.
    (function guardAgainstTampering() {
        if (!cachedInitialColor) return;
        const target = cachedInitialColor.trim().toLowerCase();
        const guardDurationMs = 2500;
        const startTime = Date.now();

        function checkAndFix() {
            const wrongFound = Array.from(
                addonsContainer.querySelectorAll('input.addon-color-swatch-input:checked')
            ).some(input => input.value.trim().toLowerCase() !== target);

            if (wrongFound) {
                syncAddonColors(cachedInitialColor);
                updateHiddenFields();
            }

            if (Date.now() - startTime < guardDurationMs) {
                requestAnimationFrame(checkAndFix);
            }
        }

        requestAnimationFrame(checkAndFix);
    })();
}

// Helper function to get currency symbol from the page
function getCurrencySymbol() {
    // Try to find currency symbol from existing price elements
    const priceElement = document.querySelector('.price__current, .money, [data-price]');
    if (priceElement) {
        const text = priceElement.textContent.trim();
        const match = text.match(/^([^\d\s]+)/);
        if (match) return match[1];
    }
    
    // Fallback to common currencies
    return '$';
}